module.exports = __webpack_public_path__ + "img/emp-2.b22f08f0.jpeg";